// @mui
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import CardHeader from '@mui/material/CardHeader';
//
import { AddressItem } from '../address';
import { AccountDto, AddressDto } from '../../api';
import { useLocales } from '../../locales';

// ----------------------------------------------------------------------

type Props = {
  addressBook: AddressDto[];
  member: AccountDto;
};

export default function AccountBillingAddress({ addressBook, member }: Props) {
  const { t } = useLocales();

  return (
    <Card>
      <CardHeader title={t('Address Book')} />

      <Stack spacing={2.5} sx={{ p: 3 }}>
        {addressBook.map((address) => (
          <AddressItem
            variant="outlined"
            key={`address-${address.id}`}
            address={address}
            member={member}
            sx={{
              p: 2.5,
              borderRadius: 1,
            }}
          />
        ))}
      </Stack>
    </Card>
  );
}
